import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppProvider } from './app/AppContext';
import { Layout } from './app/Layout';
import { ComparePage } from './pages/ComparePage';
import { DiscoverPage } from './pages/DiscoverPage';
import { FeedbackPage } from './pages/FeedbackPage';
import { FragranceDetailPage } from './pages/FragranceDetailPage';
import { LandingPage } from './pages/LandingPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PreferencesPage } from './pages/PreferencesPage';
import { ProfilePage } from './pages/ProfilePage';
import { RecommendationsPage } from './pages/RecommendationsPage';
import { StyleEditorPage } from './pages/StyleEditorPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: 'discover', element: <DiscoverPage /> },
      { path: 'style', element: <StyleEditorPage /> },
      { path: 'preferences', element: <PreferencesPage /> },
      { path: 'recommendations', element: <RecommendationsPage /> },
      { path: 'compare', element: <ComparePage /> },
      { path: 'fragrance/:id', element: <FragranceDetailPage /> },
      { path: 'feedback/:id', element: <FeedbackPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);

export default function App() {
  return <AppProvider><RouterProvider router={router} /></AppProvider>;
}
